var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82706 12.3615C6.75106 12.4275 5.83306 11.6175 5.76406 10.5495C5.70006 9.48048 6.50606 8.55648 7.58406 8.48848C8.64906 8.42048 9.56506 9.23648 9.63306 10.3045C9.70206 11.3735 8.89306 12.2955 7.82706 12.3615ZM25.6958 9.48249C24.4398 8.21149 22.3638 8.43149 21.1398 9.72849C19.5468 11.4005 18.3078 12.0255 16.8308 11.9635C14.7708 11.8735 13.7538 10.2795 12.6968 8.26949C11.5978 6.17049 9.90676 5.00049 7.79976 5.00049C4.48576 5.00049 2.49976 7.68349 2.49976 10.6755C2.49976 15.2795 5.73676 18.0315 7.97776 19.1915C9.83976 20.1625 11.9108 20.5665 13.7538 20.6135C13.6448 21.7135 13.3208 23.1665 12.9638 24.1955H13.1528H14.8728H16.5908H16.7538C16.3808 23.1665 16.0498 21.5935 15.9478 20.4905C21.5008 19.7695 24.1388 17.2485 25.5828 14.8475C26.2308 13.7935 26.5768 12.6995 26.5728 11.7165C26.5678 10.8555 26.2938 10.0725 25.6958 9.48249Z",
    fill: "#6EB329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/교보증권-30.06362f866674277228e918d03530a31d.svg";
export { ForwardRef as ReactComponent };